<template>
  <MyDealers is-widget v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import MyDealers from "./MyDealers.vue";

export default {
  name: "MyDealersWidget",
  components: {
    MyDealers
  }
};
</script>
